import { RootState } from '../../';
import { createSelector } from '@reduxjs/toolkit';

// export const selectProviderState = (state: RootState): ProviderStateInterface => {
//   if (state.admin.connectedClinician) {
//     return state.admin.connectedClinician;
//   }
//   return state.provider && state.provider.status === 'Initialized' ? state.provider : null;
// };

export const selectProviderAppSettings = (state: RootState) =>
  selectProviderState(state)?.appSettings;

export const selectProviderUserInfo = (state: RootState) => selectProviderState(state)?.userInfo;

export const selectProviderProductOffering = (state: RootState) =>
  selectProviderState(state)?.product;

export const selectProviderUserSettings = (state: RootState) =>
  selectProviderState(state)?.userSettings;

export const selectNextPasswordResetInstantEpochInSeconds = (state: RootState) =>
  selectProviderAppSettings(state)?.passwordResetInstantEpochInSeconds;

export const selectProviderName = (state: RootState) => selectProviderUserInfo(state)?.name;

export const selectIsNoteTemplatesEnabled = (state: RootState) =>
  selectProviderUserSettings(state)?.noteTemplatesEnabled &&
  selectProviderNoteTemplates(state)?.length > 0;

export const selectIsEdEnabled = (state: RootState) =>
  !!selectProviderUserSettings(state)?.edEnabled ||
  selectProviderUserInfo(state)?.specialtyName === 'Emergency Medicine';

export const selectCareCuesEnabled = (state: RootState) =>
  !!selectProviderUserSettings(state)?.enabledNudges;

export const selectIsMarkdownSupportEnabled = (state: RootState) =>
  !!selectProviderUserSettings(state)?.markdownSupport;

export const selectIsPinEnabled = (state: RootState) =>
  !!selectProviderUserSettings(state)?.pinEnabled;

export const selectHasPasscodeEnabled = (state: RootState) =>
  !!selectProviderAppSettings(state)?.glassPermutationKey;

export const selectIsHCAHardStops = (state: RootState) =>
  !!selectProviderUserSettings(state)?.hcaHardStops;

export const selectAdminProviderState = (state: RootState) => state.provider;

export const selectLoggedInProvider = (state: RootState) => state.provider;

export const selectLoggedInProviderUserInfo = (state: RootState) =>
  selectLoggedInProvider(state)?.userInfo;

export const selectProviderNoteTemplates = (state: RootState) =>
  selectProviderState(state)?.noteTemplates;

export const selectLoggedInProviderName = (state: RootState) =>
  selectLoggedInProviderUserInfo(state)?.name;

export const selectIsProviderAdmin = createSelector(
  [selectAdminProviderState],
  (providerState) => providerState?.userSettings?.providerAdmin,
  {
    memoizeOptions: {
      equalityCheck: (a, b) => a === b,
    },
  },
);

export const selectAdminProviderId = createSelector([selectAdminProviderState], (providerState) => {
  return providerState?.userInfo?.uid;
});

export const selectConnectedProviderState = (state: RootState) => {
  return state.admin?.connectedClinician;
};

export const selectConnectedProviderGuid = (state: RootState) =>
  selectConnectedProviderState(state)?.userInfo?.guid;

export const selectProviderState = createSelector(
  [selectConnectedProviderState, selectLoggedInProvider],
  (connectedProviderState, provider) => {
    if (connectedProviderState) {
      return connectedProviderState && connectedProviderState.status === 'Initialized'
        ? connectedProviderState
        : null;
    }

    return provider && provider.status === 'Initialized' ? provider : null;
  },
);
//   (state: RootState) => {
//   return state.provider.userInfo.uid;
// }
